import { URLS } from '../const/nav'
import { authFetch } from '../services/authFetch'

export const useRestoreImage = () => {
  const getImage = async (id) => {
    try {
      const response = await authFetch(`${URLS.BACKEND_URL}/imagenes/archivo/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      return response
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const restoreImageMetadata = async (id) => {
    try {
      const response = await authFetch(`${URLS.BACKEND_URL}/imagenes/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      const data = await response.json()
      return {
        id: data.idHash,
        eye: data.ojo,
        eyeKey: data.ojo === 0 ? 'leftEye' : 'rightEye',
        iluminacion: data.iluminacion,
        contraste: data.contraste,
        enfoque: data.enfoque,
        probabilidad: data.probabilidad,
        riesgoIA: data.hayRiesgo_IA,
        status: data.calidad,
        manualStatus: data.calidad_manual
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const getOriginalImageUrl = async (id) => {
    try {
      const response = await authFetch(`${URLS.BACKEND_URL}/imagenes/archivo/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      return URL.createObjectURL(await response.blob())
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const getHeatMapImages = async (id) => {
    try {
      const responseNHM = await authFetch(`${URLS.BACKEND_URL}/imagenes/cropped/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      const responseHM = await authFetch(`${URLS.BACKEND_URL}/imagenes/heatmap/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      return {
        NHM: URL.createObjectURL(await responseNHM.blob()),
        HM: URL.createObjectURL(await responseHM.blob())
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const getHeatMapImagesWithState = async (id) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
      }
      const [responseNHM, responseHM] = await Promise.all([
        authFetch(`${URLS.BACKEND_URL}/imagenes/cropped/${id}`, { method: 'GET', headers }),
        authFetch(`${URLS.BACKEND_URL}/imagenes/heatmap/${id}`, { method: 'GET', headers })
      ])

      if (responseNHM.status === 404 || responseHM.status === 404) {
        return { state: 'absent' }
      }
      if (!responseNHM.ok || !responseHM.ok) {
        return { state: 'error' }
      }

      const [blobNHM, blobHM] = await Promise.all([responseNHM.blob(), responseHM.blob()])
      return {
        state: 'ready',
        NHM: URL.createObjectURL(blobNHM),
        HM: URL.createObjectURL(blobHM)
      }
    } catch (error) {
      console.error(error)
      return { state: 'error' }
    }
  }

  const restoreImage = async (id, heatMap) => {
    try {
      const response = await authFetch(`${URLS.BACKEND_URL}/imagenes/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${JSON.parse(sessionStorage.getItem('_user')).token}`
        }
      })
      const img = await getImage(id)
      const imgHeatMap = heatMap ? await getHeatMapImages(id) : null
      const data = await response.json()
      return {
        id: data.idHash,
        eye: data.ojo,
        image: URL.createObjectURL(await img.blob()),
        heatMapImage: imgHeatMap || null,
        iluminacion: data.iluminacion,
        contraste: data.contraste,
        enfoque: data.enfoque,
        probabilidad: data.probabilidad,
        riesgoIA: data.hayRiesgo_IA,
        status: data.calidad,
        manualStatus: data.calidad_manual
        // Falta nombre
      }
    } catch (error) {
      console.error(error)
      return null
    }
  }

  return { restoreImage, restoreImageMetadata, getOriginalImageUrl, getHeatMapImages, getHeatMapImagesWithState }
}
